import { viewportBounds } from '@opendoor/shared-ts/geo-viewport';

import type {
  MarketplaceGeoPointInput,
  MarketplaceSearchAreaInput,
} from '../browse/__generated__/marketplace-browse.zeus';

export const viewportSearchArea = (
  vertices: MarketplaceGeoPointInput[],
): MarketplaceSearchAreaInput => {
  const bounds = viewportBounds(vertices);
  return bounds && bounds.west > bounds.east ? { bounds } : { vertices };
};
